import React from "react";
import MUIDataTable from "mui-datatables";
  import axios from 'axios';
  import { connect } from "react-redux";
  import ViewMarkedScriptToolbarSelect from "../toolbar/ViewMarkedScriptToolbarSelect";
  import {addAvailableScripts} from "actions/index";
  import Loader from 'react-loader-spinner';

  import {ToastContainer, toast} from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

  const columns = [
    {
     name: "name",
     label: "Learner Name",
     options: {
      filter: true,
      sort: true,
     }
    },
    
    {
     name: "grade",
     label: "Grade",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "assessment",
     label: "Assessment",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "content_type",
      label: "Content Type",
      options: {
       filter: true,
       sort: true,
      }
     }
     ,
    {
      name: "assessed",
      label: "Assessed",
      options: {
       filter: true,
       sort: true,
      }
     },
    {
        name: "created_at",
        label: "Created At",
        options: {
         filter: true,
         sort: true,
        }
       }
   ];
   
   const options = {
     filterType: 'checkbox',
     customToolbarSelect: selectedRows => (
      <ViewMarkedScriptToolbarSelect selectedRows={selectedRows} />
    )
   };
   const mapStateToProps = state => ({
    subject_selected: state.subject_selected,
    course_name: state.course_name,
    available_scripts: state.available_scripts
  });

  function mapDispatchToProps(dispatch) {
    return {
      addAvailableScripts: available_scripts => dispatch(addAvailableScripts(available_scripts))
    };
  }

class MarkedTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            subject_selected:this.props.subject_selected,     
            available_scripts:[],
            course_name: '',
            table_data:[],
            tableDataLoading:true,
            marker_codes:[]
        };  
        this.getAvailableScriptsMarked = this.getAvailableScriptsMarked.bind(this); 
        this.parseTableData = this.parseTableData.bind(this);   
        this.getAvailableScriptsAssigned = this.getAvailableScriptsAssigned.bind(this);   
      }

      componentDidMount(){
          //console.log('checking scriptss',this.props);
          let user_role = localStorage.getItem('userRole');
          if(user_role==='app-admin'){
            this.getAvailableScriptsMarked();
          }else{
            this.getMarkerCodes();            
          }          
      }

      
      getMarkerCodes(){
        let user_id = localStorage.getItem('user_id');
        let token = localStorage.getItem('access_token');
        let cur = this;
            axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-user-marker-codes/'+user_id, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                //console.log('marker codes', res.data);
                this.setState({marker_codes: res.data.marker_codes});
                this.getAvailableScriptsAssigned();
    
            }).catch(error => {
                //console.log('error', error);
                toast('An error occurred getting marer codes.'+error, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  type: toast.TYPE.ERROR
              });
            });
      }

      getAvailableScriptsAssigned(){
        let data = {
          course_id:this.state.subject_selected,
          marker_codes: this.state.marker_codes
        };
    
        axios({
          headers: {
              'content-type': 'application/json'
          },
          method: 'post',
          url: 'https://admin.thinkdigitalacademy.org/api/marker-portal-get-available-scripts-assigned-marked',
          data: data
      }).then(res => {
        this.setState({available_scripts:res.data.scripts,course_name:res.data.course.name});
        
        this.parseTableData();             
       //console.log('Check state data',this.state);
             
      }).catch(error => {
          let error_result = error.response;
          toast('An error occurred getting grades.'+error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: toast.TYPE.ERROR
        });
      });
      }

      getAvailableScriptsMarked(){       
        
        axios.get('https://admin.thinkdigitalacademy.org/api/marker-portal-get-available-scripts-marked/'+this.state.subject_selected).then(res=>{
              console.log('scripts',res.data.course.name);   
              this.setState({available_scripts:res.data.scripts,course_name:res.data.course.name});
              this.props.addAvailableScripts(res.data.scripts);
              this.parseTableData();             
             //console.log('Check state data',this.state);
          }).catch(error =>{
              //console.log('error',error);
              toast('An error occurred fetch marked scripts.'+error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
          }); 
      }

      parseTableData(){
        //console.log('checkdata',this.state.available_scripts);
        let temp = [];

       let temps = this.state.available_scripts.sort(function(a, b) {
        let fullnameA=a.student.name+" "+a.student.surname;
          let fullnameB=b.student.name+" "+b.student.surname;
          return fullnameA.localeCompare(fullnameB);
      });

        let data = temps.map((prop, key)=>{  
              
          if(prop.student && prop.grade && prop.assessment&&prop.assessed){
            temp.push(prop);
            return [prop.student.name+' '+prop.student.surname,prop.grade.grade_name,prop.assessment.assessment_name,prop.content_type,prop.assessed,prop.created_at]

          }
        });
        
        this.props.addAvailableScripts(temp);
        //console.log("prop check",data);  
        var filtered = data.filter(function (el) {
          return el != null;
        });
        
        //console.log('filtered',filtered);
        this.setState({table_data:filtered,tableDataLoading:false});
      }

render(){
    return( 
      this.state.tableDataLoading ?<Loader
      type="Puff"
      color="#00BFFF"
      height={100}
      width={100}
      timeout={3000} //3 secs

   />:<> <ToastContainer position="top-right"
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   closeOnClick
   rtl={false}
   pauseOnFocusLoss
   draggable
   pauseOnHover/>
<ToastContainer/>
    <MUIDataTable
        title={this.state.course_name}
        data={this.state.table_data}
        columns={columns}
        options={options}
      />    </>
    );
  
} 

} export default connect(mapStateToProps,mapDispatchToProps)(MarkedTable);